export enum WidgetSize {
  xsmall = 'xs',
  small = 'sm',
  medium = 'md',
  large = 'lg',
  xlarge = 'xl'
}
